import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropzone", "fileInput", "form", "idle", "loading"]

  connect() {
    this._dragCounter = 0

    this._onDragEnter = (e) => {
      if (this._hasFiles(e)) { this._dragCounter++; this._highlight() }
    }
    this._onDragLeave = (e) => {
      if (this._hasFiles(e)) {
        this._dragCounter--
        if (this._dragCounter <= 0) this._unhighlight()
      }
    }
    this._onDragOver = (e) => {
      if (this._hasFiles(e)) { e.preventDefault(); e.dataTransfer.dropEffect = "copy" }
    }
    this._onDrop = (e) => {
      if (!this._hasFiles(e)) return
      e.preventDefault()
      this._dragCounter = 0
      this._unhighlight()
      const file = e.dataTransfer.files[0]
      if (file) this._submitFile(file)
    }

    document.addEventListener("dragenter", this._onDragEnter)
    document.addEventListener("dragleave", this._onDragLeave)
    document.addEventListener("dragover", this._onDragOver)
    document.addEventListener("drop", this._onDrop)
  }

  disconnect() {
    document.removeEventListener("dragenter", this._onDragEnter)
    document.removeEventListener("dragleave", this._onDragLeave)
    document.removeEventListener("dragover", this._onDragOver)
    document.removeEventListener("drop", this._onDrop)
  }

  browse() {
    this.fileInputTarget.click()
  }

  fileSelected() {
    const file = this.fileInputTarget.files[0]
    if (file) this._submitFile(file)
  }

  _submitFile(file) {
    const dt = new DataTransfer()
    dt.items.add(file)
    this.fileInputTarget.files = dt.files
    this._showLoading()
    this.formTarget.requestSubmit()
  }

  _showLoading() {
    this.idleTarget.classList.add("hidden")
    this.loadingTarget.classList.remove("hidden")
  }

  _highlight() {
    this.dropzoneTarget.classList.add("border-blue-500", "bg-blue-50")
    this.dropzoneTarget.classList.remove("border-gray-300")
  }

  _unhighlight() {
    this.dropzoneTarget.classList.remove("border-blue-500", "bg-blue-50")
    this.dropzoneTarget.classList.add("border-gray-300")
  }

  _hasFiles(e) {
    return e.dataTransfer?.types && Array.from(e.dataTransfer.types).includes("Files")
  }
}
